<template>
  <v-form>
    <v-card-text>
      <v-text-field
        v-model="item.login"
        :error-messages="loginErrors"
        :label="$t('administration.user.login')"
        prepend-icon="mdi-account-circle"
        required
        @input="$v.item.login.$touch()"
        @blur="$v.item.login.$touch()"
      ></v-text-field>
      <v-text-field
        v-model="item.password"
        type="password"
        :error-messages="passwordErrors"
        :label="$t('administration.user.password')"
        prepend-icon="mdi-onepassword"
        required
        @input="$v.item.password.$touch()"
        @blur="$v.item.password.$touch()"
        v-on:keyup.enter="submitlogin"
      ></v-text-field>
    </v-card-text>
  </v-form>
</template>

<script>
  import has from 'lodash/has';
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  export default {

    name: 'LoginForm',
    mixins: [validationMixin],
    props: {
      values: {
        type: Object,
        required: true
      },
      errors: {
        type: Object,
        default: () => {}
      },
      initialValues: {
        type: Object,
        default: () => {}
      },
      submitlogin: {
        type: Function,
        required: true
      }
    },
    data () {
      return {
        login: null,
        password: null,
      }
    },
    computed: {

      // eslint-disable-next-line
      item() {
        return this.initialValues || this.values;
      },

      loginErrors() {
        const errors = [];

        if (!this.$v.item.login.$dirty) return errors;

        has(this.violations, 'login') && errors.push(this.violations.login);

        !this.$v.item.login.required && errors.push(this.$t('global.field_required'));

        return errors;
      },
      passwordErrors() {
        const errors = [];

        if (!this.$v.item.password.$dirty) return errors;

        has(this.violations, 'password') && errors.push(this.violations.password);

        !this.$v.item.password.required && errors.push(this.$t('global.field_required'));

        return errors;
      },

      violations() {
        return this.errors || {};
      }
    },
    methods: {

    },
    validations: {
      item: {
        login: {
          required,
        },
        password: {
          required,
        },
      }
    }
  }
</script>
